// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__29-JE","rightAdornment":"Header_rightAdornment__1faaH"};